export const CARD_CLASS = "card";
export const DEFAULT_CONTACT_SALES_LINK = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales";
export const DEFAULT_CONTACT_SALES_LINK_ULTIMATE_RENAME = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales&utm_content=ultimate_rename";
